export default __webpack_public_path__ + "static/media/Marika_Flygar.856aebdc.jpg";